import { getQueryMethod, resources, entities, getURLParams } from '../utils';
const { meloAPI } = resources;
const { accountability } = entities;

const query = getQueryMethod(meloAPI, accountability);

const endpoints = {
  getWorldOfficeWorksheetNotaContabilidad: async (businessId, date1, date2) => {
    const queryParams = getURLParams({ businessId, date1, date2 });
    return await query(`world-office/nota-contabilidad?${queryParams}`);
  },
  getWorldOfficeWorksheetTercerosConDirecciones: async businessId => {
    const queryParams = getURLParams({ businessId });
    return await query(`world-office/terceros-con-direcciones?${queryParams}`);
  }
};

export default endpoints;
